import ContactSupportButton from "../ContactSupportButton";
import { ServerError } from "../../infra/ErrorResponse";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const getGeneralErrorText = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: ["Payment method connection failed. Please retry or ", /*#__PURE__*/_jsx(ContactSupportButton, {}), " for help."]
});
export function mapErrorToMessage(e) {
  if (e.hasServerError(ServerError.BankTransferAccountBlocked)) {
    return 'Verification failed. The account you tried to connect is invalid for verification using micro-deposits. Please connect a different account.';
  } else {
    return getGeneralErrorText();
  }
}